import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import styles from "./FilterModal.module.scss";
import { getAllUsers, setFilters } from "reducer/admin/userMangenmentSlice";
import { useDispatch, useSelector } from "react-redux";
import { statusOptions, userTypeOptions } from "constants/constants";
import SelectCustom from "components/common/Select/Select";
import { selectDropdownStyles } from "../constants";
import { selectMapper } from "utils/utils";
import { SelectStyles } from "utils/constants";
import { API } from "service/Interceptor";
import toast from "react-hot-toast";

const FilterModal = ({ onClose, search }) => {
  const formDropdownFields = [
    { label: "User Type", key: "userType", options: userTypeOptions },
    { label: "Status", key: "status", options: statusOptions },
  ];

  const { filters } = useSelector((state) => state.users);

  const { register, handleSubmit, setValue, reset, watch, control } = useForm({
    defaultValues: {
      fromDate: filters.fromDate?.split("T")[0] || "",
      toDate: filters.toDate?.split("T")[0] || "",
      userType: filters.userType || null,
      status: filters.status || null,
      preference: filters.preference || null,
    },
  });
  const dispatch = useDispatch();
  const fromDate = watch("fromDate");
  const toDate = watch("toDate");
  const [preference, setPreferences] = useState([]);
  const newCategories = selectMapper(preference);

  const isFilterActive = () => {
    const values = watch();
    return (
      values.fromDate ||
      values.toDate ||
      values.userType ||
      values.status ||
      (Array.isArray(values.preference) && values.preference.length > 0)
    );
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  // const onSubmit = (data) => {
  //   const { fromDate, toDate, ...rest } = data;
  //   let obj = {
  //     fromDate: fromDate ? new Date(fromDate).toISOString() : null,
  //     toDate: toDate ? new Date(toDate).toISOString() : null,
  //     ...rest,
  //   };
  //   dispatch(getAllUsers({ search, ...obj }));
  //   onClose(); // or pass data to parent
  // };

  const onSubmit = (data) => {
    const categoryIds = Array.isArray(data.preference)
      ? data.preference.map((item) => item.value).join(",")
      : "";
    const payload = {
      fromDate: data.fromDate ? new Date(data.fromDate).toISOString() : "",
      toDate: data.toDate ? new Date(data.toDate).toISOString() : "",
      categoryIds:
        Array.isArray(data.preference) && data.preference.length
          ? data.preference.map((p) => p.value).join(",")
          : "",
      preference: data.preference,
      userType: data.userType,
      isActive: data.status,
    };
    dispatch(setFilters(payload));
    dispatch(getAllUsers({ pageSelected: 1, search, filters: payload }));
    onClose();
  };

  const resetAll = () => {
    reset({
      fromDate: "",
      toDate: "",
      status: "",
      flaggedStatus: "",
      preference: [],
    });

    dispatch(
      setFilters({
        fromDate: "",
        toDate: "",
        status: "",
        userType: "",
        preference: [],
      }),
    );
    dispatch(getAllUsers({ pageSelected: 1, search: search, filters: {} }));
    onClose();
  };
  const getCategories = async () => {
    try {
      const res = await API.get("api/categories");
      if (res?.data?.data?.results?.length > 0) {
        setPreferences(res?.data?.data?.results);
      } else {
        toast.error("No categories found.");
      }
    } catch (error) {
      toast.error("Failed to fetch categories.");
    }
  };
  useEffect(() => {
    getCategories();
  }, []);

  return (
    <div
      className={styles.overlay}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <form className={styles.modal} onSubmit={handleSubmit(onSubmit)}>
        <div className={styles.dragBar} />

        <p className={styles.title}>Filter by:</p>

        {/* Date Range */}
        <div className={styles.section}>
          <div className={styles.labelRow}>
            <label>Date Range</label>
            <button
              type="button"
              // onClick={handleResetDates}
              onClick={() => {
                setValue("fromDate", "");
                setValue("toDate", "");
              }}
            >
              Reset
            </button>
          </div>
          <div className={styles.dateRow}>
            <input
              type="date"
              {...register("fromDate")}
              max={toDate || undefined}
            />
            <input
              type="date"
              {...register("toDate")}
              min={fromDate || undefined}
            />
          </div>
        </div>

        {formDropdownFields?.map(({ label, key, options }) => (
          <div className={styles.section} key={key}>
            <div className={styles.labelRow}>
              <span>{label}</span>
              <button
                type="button"
                onClick={() => {
                  setValue(key, "");
                }}
              >
                Reset
              </button>
            </div>
            <Controller
              name={key}
              control={control}
              render={({ field }) => {
                let selectedOption;
                if (field.value) {
                  selectedOption = options.find(
                    (option) => option.value === field.value,
                  );
                  console.log("selectedOption", selectedOption);
                } else {
                  selectedOption = "";
                }
                return (
                  <SelectCustom
                    {...field}
                    options={options}
                    value={selectedOption}
                    styles={selectDropdownStyles()}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption?.value);
                    }}
                  />
                );
              }}
            />
          </div>
        ))}
        <div className={styles.section}>
          <div className={styles.labelRow}>
            <span>Niche</span>
            <button
              type="button"
              onClick={() => {
                setValue("preference", []);
              }}
            >
              Reset
            </button>
          </div>
          <Controller
            name="preference"
            control={control}
            render={({ field }) => (
              <>
                <SelectCustom
                  {...field}
                  classNamePrefix="filter-niche"
                  placeholder="Select Niche"
                  options={newCategories.filter(
                    (category) =>
                      !field?.value?.some(
                        (f_v) => f_v?.value == category?.value,
                      ),
                  )}
                  value={field.value}
                  // menuIsOpen={undefined}
                  onChange={(selected) => {
                    field.onChange(selected);
                  }}
                  styles={selectDropdownStyles()}
                  searchable={true}
                  isMulti={true}
                  // isDisplay={true}
                  data={field}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  menuShouldBlockScroll={true}
                />
              </>
            )}
          />
        </div>
        {/* Footer Buttons */}
        <div className={styles.footer}>
          <button
            type="button"
            className={`${styles.resetBtn} ${!isFilterActive() ? "disabled" : ""}`}
            onClick={resetAll}
            disabled={!isFilterActive()}
          >
            Reset All
          </button>
          <button
            type="submit"
            className={`${styles.applyBtn} ${!isFilterActive() ? "disabled" : ""}`}
            disabled={!isFilterActive()}
          >
            Apply Filters
          </button>
        </div>
      </form>
    </div>
  );
};

export default FilterModal;
